import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import BasicLayout from "@/layouts/BasicLayout.vue";
import UserLayout from "@/layouts/UserLayout.vue";
import userLayout from "@/layouts/UserLayout.vue";
import enterpriseLayout from "@/layouts/EnterpriseLayout.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "main",
    component: BasicLayout,
    children: [
      {
        path: "",
        name: "home",
        component: () => import("@/pages/HomePage.vue"),
      },
      {
        path: "about",
        name: "about",
        component: () => import("@/pages/AboutPage.vue"),
      },
      {
        path: "/user-login",
        name: "userLogin",
        component: () => import("@/pages/user-login/UserLoginPage.vue"),
      },
      {
        path: "/user-login/user-password-forget",
        name: "userPasswordForget",
        component: () =>
          import("@/pages/user-login/UserPasswordForgetPage.vue"),
      },
      {
        path: "/user-login/user-register",
        name: "userRegister",
        component: () => import("@/pages/user-login/UserRegisterPage.vue"),
      },

      {
        path: "/enterprise-login",
        name: "enterpriseLogin",
        component: () =>
          import("@/pages/enterprise-login/EnterpriseLoginPage.vue"),
      },
      {
        path: "/enterprise-login/enterprise-password-forget",
        name: "enterprisePasswordForget",
        component: () =>
          import("@/pages/enterprise-login/EnterprisePasswordForgetPage.vue"),
      },
      {
        path: "/enterprise-login/enterprise-register",
        name: "enterpriseRegister",
        component: () =>
          import("@/pages/enterprise-login/EnterpriseRegisterPage.vue"),
      },
    ],
  },
  {
    path: "/user",
    name: "user",
    component: UserLayout,
    children: [
      {
        path: "/user/userHome",
        name: "userHome",
        component: () => import("@/pages/user/userHomePage.vue"),
      },
      {
        path: "/user/userTaskPool",
        name: "userTaskPool",
        component: () => import("@/pages/user/userTaskPoolPage.vue"),
      },
    ],
  },
  {
    path: "/enterprise",
    name: "enterprise",
    component: enterpriseLayout,
    children: [
      {
        path: "/enterprise/enterpriseHome",
        name: "enterpriseHome",
        component: () => import("@/pages/enterprise/enterpriseHomePage.vue"),
      },
      {
        path: "/enterprise/enterpriseProject",
        name: "enterpriseProject",
        component: () => import("@/pages/enterprise/enterpriseProjectPage.vue"),
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
